import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonVariant } from "components/base/Button";
import ModalExcluirConta from "./ModalExcluirConta";
import { ContaType } from "services/contaService";

interface BotaoExcluirContaProps {
    conta: ContaType;
    size?: "sm" | "lg";
    variant?: ButtonVariant;
    title?: string;
}

const BotaoExcluirConta: React.FC<BotaoExcluirContaProps> = ({
    conta,
    size = "sm",
    variant = "outline-danger",
    title = "Excluir"
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                onClick={handleClick}
                title={title}
            >
                <FontAwesomeIcon icon={faTrash} />
            </Button>

            <ModalExcluirConta
                show={showModal}
                onHide={handleClose}
                conta={conta}
            />
        </>
    );
};

export default BotaoExcluirConta; 